<template>
  <div class="scale_inputjl">
    <div class="area_box jlbox" ref="areabox" :style="{'width':width+'px','height':height+'px'}">
      <table class="jltable" style="display: block" ref="area">
        <tr v-for="(itemjl,indexjl) in jlArr">
          <td style="min-width: 116px;white-space: nowrap;vertical-align: top;height: auto;text-align: left;">{{Object.keys(itemjl)[0]}}</td>
          <td style="padding-left:10px;text-align: left;vertical-align: top;height: auto;white-space: pre-wrap">{{Object.values(itemjl)[0]}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>

export default {
  components: {},
  props: {
    jlArr:Array,
    width:Number,
    height: Number
  },
  computed: {},
  watch: {
    jlArr:function (val){
      if(val != null && val.length > 0 ){
        setTimeout(()=>{
          this.blurText();
        },100)

      }
    }
  },
  data() {
    return {
      scaleVal: 1
    }
  },
  mounted() {
    console.log("inputjl",this.jlArr)
  },
  methods: {
    blurText() {
      let $el = $(this.$refs.area);
      let $boxel = $(this.$refs.areabox);
      console.log($el)
      this.scaleVal = 1;
      $el.css({
        "transform": `scale(${this.scaleVal})`,
        "height":'100%',
        "width":"100%",
        "position":"relative",
        "top": 0,
        "left":0,
      })
      let areaScrollHeight = $el[0].scrollHeight;
      let areaClientHeight = $el[0].clientHeight;
      let boxClientHeight = $boxel[0].clientHeight;
      if(areaScrollHeight <= boxClientHeight){
        $el.css({
          "height": areaScrollHeight,
          "text-align":'left'
        })
        $boxel.css({
          "display":"flex",
          "align-items":"flex-start"
        })
      }else {
        $el.css({
          "height": "100%",
          "text-align":"left"
        })
        this.recurScale();

        // if(this.type === 'l_c' || this.type === 'c_c'){
        //   $el.css({
        //     "height": 10
        //   })
        //   $el.css({
        //     "height": $el[0].scrollHeight,
        //     "top": -(boxClientHeight/(this.scaleVal))*(1-this.scaleVal)/2 + (boxClientHeight - $el[0].scrollHeight*this.scaleVal)/(2*this.scaleVal),
        //     // "left":-(boxClientWidth/(this.scaleVal))*(1-this.scaleVal)/2
        //   })
        //   console.log("nmd",(boxClientHeight - $el[0].scrollHeight*this.scaleVal)/2)
        //
        // }
      }
    },
    recurScale(){
      console.log($(this.$refs.area))
      let $el = $(this.$refs.area);
      let $boxel = $(this.$refs.areabox);
      let areaScrollHeight = $el[0].scrollHeight;
      let areaClientHeight = $el[0].clientHeight;
      let boxClientWidth = $boxel[0].clientWidth;
      let boxClientHeight = $boxel[0].clientHeight;
      if (areaScrollHeight > areaClientHeight && this.scaleVal >= 0.05) {
        this.scaleVal -= 0.05;
        $el.css({
          "transform": `scale(${this.scaleVal})`,
          "height": boxClientHeight/(this.scaleVal),
          "width": boxClientWidth/(this.scaleVal),
          "position":"relative",
          "top": -(boxClientHeight/(this.scaleVal))*(1-this.scaleVal)/2,
          "left":-(boxClientWidth/(this.scaleVal))*(1-this.scaleVal)/2
        })
        this.recurScale();
      }
    }
  }
}
</script>
<style lang="less">
.scale_inputjl{
  .area_box{
    //border: 1px solid black;
    cursor: text;
    overflow: hidden;
  }
}
</style>